import { IEmployeeHypermediaRepresentation, IEmployeesFlat } from '@/contracts/EmployeeContract';
import { DataSource } from './abstract-data-source';
import { AbstractDataSourceType } from './abstract-data-source-type';

interface EmployeeIdToEmployeeHash {
    [id: string]: EmployeeDataType;
}

interface TribesToEmployeeIdsHash {
    [id: string]: string[];
}

interface HivesToEmployeeIdsHash {
    [id: string]: string[];
}

interface EngagementManagerIdToCoachees {
    [idEmployee: string]: EmployeeDataType[];
}

interface LTCoachIdToLTCoachees {
    [employeeId: string]: EmployeeDataType[];
}

interface FirestaerterIdToCoachees {
    [employeeId: string]: EmployeeDataType[];
}

export interface EmployeeDataType extends AbstractDataSourceType, IEmployeeHypermediaRepresentation {}

export class EmployeesDataSource extends DataSource {
    public data: EmployeeDataType[];
    public functionSeniorShipCodes: string[];

    public employeeIdToEmployee: EmployeeIdToEmployeeHash = {};
    public employeeIdToSkillIds: { [employeeId: string]: string[] } = {};
    public engagementManagerIdToCoachees: EngagementManagerIdToCoachees = {};
    public tribesToEmployees: TribesToEmployeeIdsHash = {};
    public hivesToEmployees: HivesToEmployeeIdsHash = {};
    public ltCoachesToCoachees: LTCoachIdToLTCoachees = {};
    public firestaerterIdToCoachees: FirestaerterIdToCoachees = {};

    constructor(employeesFlat: IEmployeesFlat) {
        super(employeesFlat.Employees);

        this.functionSeniorShipCodes = this.data
            .map(employee => employee.FunctionLevel)
            .filter((l, index, original) => !!l && original.indexOf(l) === index);

        this.data.forEach(employee => {
            this.employeeIdToEmployee[employee.Id] = employee;
        });

        this.data.forEach(el => {
            el.StartDate = !!el.StartDate && new Date(el.StartDate.toString()); // they actually come in as  strings.

            if (!el.FunctionLevel) {
                el.FunctionLevel = 'None';
            }

            // Collect Engagement managers
            if (el.EngagementManagerId !== el.Id && this.employeeIdToEmployee[el.EngagementManagerId]) {
                if (!this.engagementManagerIdToCoachees[el.EngagementManagerId]) {
                    this.engagementManagerIdToCoachees[el.EngagementManagerId] = [];
                }
                if (this.engagementManagerIdToCoachees[el.EngagementManagerId].indexOf(el) === -1) {
                    this.engagementManagerIdToCoachees[el.EngagementManagerId].push(el);
                }
            }

            // Collect LT Coaches
            if (el.LTCoachId !== el.Id && this.employeeIdToEmployee[el.LTCoachId]) {
                if (!this.ltCoachesToCoachees[el.LTCoachId]) {
                    this.ltCoachesToCoachees[el.LTCoachId] = [];
                }
                if (this.ltCoachesToCoachees[el.LTCoachId].indexOf(el) === -1) {
                    this.ltCoachesToCoachees[el.LTCoachId].push(el);
                }
            }

            // Collect Firestaerter Coaches
            if (el.FirestaerterId !== el.Id && this.employeeIdToEmployee[el.FirestaerterId]) {
                if (!this.firestaerterIdToCoachees[el.FirestaerterId]) {
                    this.firestaerterIdToCoachees[el.FirestaerterId] = [];
                }
                if (this.firestaerterIdToCoachees[el.FirestaerterId].indexOf(el) === -1) {
                    this.firestaerterIdToCoachees[el.FirestaerterId].push(el);
                }
            }

            // Collect employees per tribe
            if (!this.tribesToEmployees[el.TribeId]) {
                this.tribesToEmployees[el.TribeId] = [];
            }
            if (this.tribesToEmployees[el.TribeId].indexOf(el.Id) === -1) {
                this.tribesToEmployees[el.TribeId].push(el.Id);
            }

            // Collect employees per hive
            if (!this.hivesToEmployees[el.HiveId]) {
                this.hivesToEmployees[el.HiveId] = [];
            }
            if (this.hivesToEmployees[el.HiveId].indexOf(el.Id) === -1) {
                this.hivesToEmployees[el.HiveId].push(el.Id);
            }
        });

        employeesFlat.Skills.forEach(employeeSkill => {
            if (!this.employeeIdToSkillIds[employeeSkill.EmployeeId]) {
                this.employeeIdToSkillIds[employeeSkill.EmployeeId] = [];
            }
            this.employeeIdToSkillIds[employeeSkill.EmployeeId].push(employeeSkill.SkillId);
        });
    }
}
